import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Totes.frontend.types'

@Injectable({ providedIn: 'root' })
export class Totes_create_delete_or_update_containersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { statusId?: number, container_type_id?: number, lookup?: string, warehouse_id?: number, action?: string, container_id?: number }): Promise<{ reasons?: string[] }> 
  {
    let $url = `${environment.backendUrl}api/Totes/functions/create_delete_or_update_containers`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

